import umiRequest, { RequestOptionsInit } from 'umi-request';

export function getCaptcha(data: { verifyUuid: string, verifyType: string, name: string }) {
  return umiRequest('/local/xiaohongshu/home/captcha/get', {
    method: 'post',
    data
  });
}

export function checkCaptcha(data: { verifyUuid: string, verifyType: string, mouseEnd: string, time: string, track: string, rid: string, name: string }) {
  return umiRequest('/local/xiaohongshu/home/captcha/check', {
    method: 'post',
    data
  });
}
